import React from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceAgreementFormComponent from './Serviceaggrementform';

const ServiceAgreementForm = () => {
    const navigate = useNavigate();

    const handleFormSubmit = () => {
        navigate('/consent-manager');
    };

    return <ServiceAgreementFormComponent onSubmitSuccess={handleFormSubmit} />;
};

export default ServiceAgreementForm;